import request from '../api';

// 新建会话
export function createSession(data) {
  return request({
    url: '/app/virtualManApi/liveSession/createSession',
    method: 'post',
    data,
  });
}

// 查询会话流状态
export function statSession(data) {
  return request({
    url: '/app/virtualManApi/liveSession/statSession',
    method: 'post',
    data,
  });
}

// 开启会话
export function startSession(data) {
  return request({
    url: '/app/virtualManApi/liveSession/startSession',
    method: 'post',
    data,
  });
}

// 关闭会话
export function closeSession(data) {
  return request({
    url: '/app/virtualManApi/liveSession/closeSession',
    method: 'post',
    data,
  });
}

// 查询项目下的会话列表
export function listSessionOfVk(data) {
  return request({
    url: '/app/virtualManApi/liveSession/listSessionOfVk',
    method: 'post',
    data,
  });
}

// 6.查询uin下的会话列表
export function listSessionOfUin(data) {
  return request({
    url: '/app/virtualManApi/liveSession/listSessionOfUin',
    method: 'post',
    data,
  });
}

// 发送文本
export function sendText(data) {
  return request({
    url: '/app/interact/sendText',
    method: 'post',
    data,
  });
}

// 发送心跳
export function sendHeartBeat(data) {
  return request({
    url: '/app/interact/sendHeartbeat',
    method: 'post',
    data,
  });
}

export function getAppInteractiveChatList(data) {
  return request({
    url: '/app/interactiveChat/getAppInteractiveChatList',
    method: 'post',
    data,
  });
}

// 发送音频
export function sendPCMAudio(data) {
  return request({
    url: '/app/interact/sendAudio',
    method: 'post',
    data,
  });
}

// 发送回复
export function sendAnswerText(data) {
  return request({
    url: '/app/interact/sendAnswerText',
    method: 'post',
    data,
  });
}

// 弹幕状态
export function checkLiveBarrage(liveRoomId) {
  return request({
    url: `/app/liveRoom/status/${liveRoomId}`,
    method: 'post',
  });
}

// 连接弹幕
export function liveRoomOpenDm(data) {
  return request({
    url: '/app/liveRoom/openDm',
    method: 'post',
    data,
  });
}

// 关闭弹幕
export function liveRoomCloseDm(liveRoomId) {
  return request({
    url: `/app/liveRoom/closeDm/${liveRoomId}`,
    method: 'post',
  });
}

// 自动回复消息
export function liveSessionAutoReply(data) {
  return request({
    url: '/app/virtualManApi/liveSession/autoReply',
    method: 'post',
    data,
  });
}

// 发送问题给LLM
export function sendLLMAskText(data) {
  return request({
    url: '/app/interact/sendLLMAskText',
    method: 'post',
    data,
  });
}

// 获取App直播间文本详情
export function getAppLiveRoomText(id) {
  return request({
    url: `/app/liveRoomText/getAppLiveRoomText/${id}`,
    method: 'post',
  });
}
// 获取App直播间文本分页列表
export function getAppLiveRoomTextPage(data) {
  return request({
    url: '/app/liveRoomText/getAppLiveRoomTextPage',
    method: 'post',
    data,
  });
}
// 删除直播间文本
export function deleteAppLiveRoomText(id) {
  return request({
    url: `/app/liveRoomText/deleteAppLiveRoomText/${id}`,
    method: 'post',
  });
}
// 添加直播间文本
export function addAppLiveRoomText(data) {
  return request({
    url: '/app/liveRoomText/addAppLiveRoomText',
    method: 'post',
    data,
  });
}
// 修改直播间文本
export function updateAppLiveRoomText(data) {
  return request({
    url: '/app/liveRoomText/updateAppLiveRoomText',
    method: 'post',
    data,
  });
}
